export class VideoBlock {
	constructor( node ) {
		this.node = node;
		if ( ! this.node ) {
			return;
		}
	}
	onPlayClick( cover, player, vid ) {
		vid.classList.add( 'is-playing' );
		cover.classList = cover.classList ?? '';
		cover.classList.add( 'hidden' );

		const contentWindow = player?.contentWindow;

		if ( contentWindow ) {
			const url = new URL( player.src );
			url.searchParams.append( 'enablejsapi', '1' );
			url.searchParams.append( 'autoplay', '1' );

			player.src = url.href;

			player.contentWindow.postMessage( '{"event":"command","func":"playVideo","args":""}', '*' );
		} else {
			player.play();
		}
	}
}
document.addEventListener( 'DOMContentLoaded', () => {
	const videos = document.querySelectorAll( '.video__wrapper' );
	videos.forEach( ( vid ) => {
		const cover = vid.querySelector( '.video__cover' );
		const video = vid.querySelector( 'video' );
		const player = video;

		const playerInstance = new VideoBlock();

		vid.addEventListener( 'click', () => playerInstance.onPlayClick( cover, player, vid ) );
	} );
} );
